exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-banners-box[data-v-54473415]{cursor:pointer}#hpBannerCarousel .carousel-control[data-v-54473415]{width:5%}#hpBannerCarousel .item[data-v-54473415]{width:100%!important}#hpBannerCarousel .item img[data-v-54473415]{display:block;width:100%!important;height:auto!important}", ""]);

// exports
